var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 16,
    height: 16,
    transform: "translate(-2 -3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10665",
    "data-name": "Groupe 10665",
    transform: "translate(-654 -6787)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4909",
    "data-name": "Rectangle 4909",
    width: 14,
    height: 14,
    transform: "translate(653 6785)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_160",
    "data-name": "Groupe 160",
    transform: "translate(653 6786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M5.881,11.368V8.121a2.2,2.2,0,0,0,1.238,0v3.247a.619.619,0,1,1-1.238,0ZM10.05,9.88a.64.64,0,0,1,.075-.89,4.369,4.369,0,0,0,1.637-3.307,4.369,4.369,0,0,0-1.637-3.307.64.64,0,0,1-.075-.89.611.611,0,0,1,.873-.077A5.622,5.622,0,0,1,13,5.684a5.622,5.622,0,0,1-2.077,4.273.611.611,0,0,1-.873-.077Zm-7.972.077A5.621,5.621,0,0,1,0,5.684,5.621,5.621,0,0,1,2.078,1.411a.611.611,0,0,1,.873.077.641.641,0,0,1-.075.89A4.371,4.371,0,0,0,1.238,5.684,4.371,4.371,0,0,0,2.875,8.991a.641.641,0,0,1,.075.89.611.611,0,0,1-.873.077ZM8.5,8.618a.642.642,0,0,1,.075-.891A2.7,2.7,0,0,0,9.6,5.684,2.7,2.7,0,0,0,8.578,3.641a.642.642,0,0,1-.078-.89.612.612,0,0,1,.873-.076,3.957,3.957,0,0,1,1.459,3.009A3.957,3.957,0,0,1,9.375,8.693a.609.609,0,0,1-.4.149A.616.616,0,0,1,8.5,8.618Zm-4.877.076a3.957,3.957,0,0,1-1.456-3.01A3.957,3.957,0,0,1,3.625,2.675a.611.611,0,0,1,.872.076.642.642,0,0,1-.075.891A2.7,2.7,0,0,0,3.4,5.684,2.7,2.7,0,0,0,4.423,7.727a.642.642,0,0,1,.075.891.615.615,0,0,1-.474.225.608.608,0,0,1-.4-.15Zm2.258-3.01a.619.619,0,1,1,.619.632.626.626,0,0,1-.619-.632ZM6.5,3.158a2.425,2.425,0,0,0-.619.089V.632a.619.619,0,1,1,1.238,0V3.247A2.418,2.418,0,0,0,6.5,3.158Z",
    fill: "#C5A47E"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2bfd1b8cc57d11f457b13395d6638b9f.svg";
export { ForwardRef as ReactComponent };